import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewLandingPageTrackingComponent } from './customer-review-landing-page-tracking.component';

runClientComponent({ customerReviewLandingPageTracking: CustomerReviewLandingPageTrackingComponent });
